/* eslint-disable max-lines, max-lines-per-function */
import { isTouchDevice } from "common/utils/browser";
import { track } from "jiffy-analytics";
import initScroll from "common/utils/ui/slider";
import "./spangle-design-inspirations.scss";

const ANIMATION_DURATION = 600;
let inAnimation = false;
let $currentLink;

// Getters
const $getLightBoxLinks = () =>
  document.querySelectorAll(".js-spangle-design-inspirations-lightbox");
const $getCarouselWrapper = () => document.querySelector(".js-spangle-design-inspirations");
const $getCarouselGrid = () =>
  $getCarouselWrapper().querySelector(".js-spangle-design-inspirations-grid");
const $getMobileArrows = () => ({
  $leftArrow: $getCarouselWrapper().querySelector(
    ".js-spangle-design-inspirations-mobile-carousel-left"
  ),
  $rightArrow: $getCarouselWrapper().querySelector(
    ".js-spangle-design-inspirations-mobile-carousel-right"
  )
});
const $getDesktopArrows = () => ({
  $leftArrow: $getCarouselWrapper().querySelector(".js-spangle-design-inspirations-left"),
  $rightArrow: $getCarouselWrapper().querySelector(".js-spangle-design-inspirations-right")
});
const $getArrows = isTouch => ({
  $leftArrow: isTouch ? $getMobileArrows().$leftArrow : $getDesktopArrows().$leftArrow,
  $rightArrow: isTouch ? $getMobileArrows().$rightArrow : $getDesktopArrows().$rightArrow
});

// Actions
const trackEvent = suffix => {
  track(`spangle_design_inspirations_${suffix}`, JSON.parse($currentLink.dataset.mixpanelData));
};
const stopTrackPropagination = () => {
  inAnimation = true;

  setTimeout(() => {
    inAnimation = false;
  }, ANIMATION_DURATION);
};

const loadMore = () => {};

const checkArrowsVisibility = async () => {
  const { $leftArrow, $rightArrow } = $getArrows(isTouchDevice());
  const $carousel = $getCarouselGrid();
  const isStartOfScroll = $carousel.scrollLeft === 0;
  let isEndOfScroll = $carousel.scrollLeft >= $carousel.scrollWidth - $carousel.clientWidth - 5;

  if (isEndOfScroll) {
    isEndOfScroll = $carousel.scrollLeft >= $carousel.scrollWidth - $carousel.clientWidth - 5;
  }

  $leftArrow.classList.toggle("hidden", isStartOfScroll);
  $rightArrow.classList.toggle("hidden", isEndOfScroll);
};

const checkTouchBrowsers = () => {
  const { $leftArrow, $rightArrow } = $getArrows(!isTouchDevice());
  $leftArrow.remove();
  $rightArrow.remove();
};

// Tracks
const trackCloseModal = () => {
  trackEvent("close_modal_window");
};
const trackPrevImage = (suffix = "click") => {
  if (!$currentLink || inAnimation) return;

  const $prevElement = $currentLink.parentElement.previousElementSibling;
  if (!$prevElement) return;

  stopTrackPropagination();
  $currentLink = $prevElement.querySelector("a");
  trackEvent(`${suffix}_prev_slide`);
};
const trackNextImage = (suffix = "click") => {
  if (!$currentLink || inAnimation) return;

  const $nextElement = $currentLink.parentElement.nextElementSibling;
  if (!$nextElement) return;

  stopTrackPropagination();
  $currentLink = $nextElement.querySelector("a");
  trackEvent(`${suffix}_next_slide`);
};

// Handlers
const handleCarouselSwipe = () => {
  let touchstartX = null;

  document.addEventListener(
    "touchstart",
    event => {
      const $handler = event.target;
      if ($handler.classList.contains("lb-next") || $handler.classList.contains("lb-prev")) {
        touchstartX = event.changedTouches[0].screenX;
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    "touchend",
    event => {
      const touchendX = event.changedTouches[0].screenX;
      const startSwipe = Math.min(window.innerWidth / 5, 100);

      if (!touchstartX || Math.abs(touchstartX - touchendX) < startSwipe) return;

      if (touchendX < touchstartX) {
        document.querySelector(".lb-next")?.click();
      } else {
        document.querySelector(".lb-prev")?.click();
      }

      touchstartX = null;
    },
    { passive: true, capture: true }
  );
};

const handleMobileCarouselScroll = () => {
  $getCarouselGrid().addEventListener("scroll", checkArrowsVisibility, { passive: true });
};

// Inits
const initNativeScroll = () => {
  checkArrowsVisibility();
  handleMobileCarouselScroll();
};

const initMixPanelEvents = () => {
  const $links = $getLightBoxLinks();

  $links.forEach($link => {
    $link.addEventListener("click", () => {
      $currentLink = $link;
    });
  });

  window.addEventListener(
    "click",
    event => {
      if (!$currentLink) return;

      const $handler = event.target;
      const isClosesHandler = ["lb-loader", "lb-close", "lightbox", "lightboxOverlay"].some(cn =>
        $handler.classList.contains(cn)
      );

      if (isClosesHandler) {
        trackCloseModal();
        $currentLink = null;
      }

      if ($handler.classList.contains("lb-next")) trackNextImage();
      if ($handler.classList.contains("lb-prev")) trackPrevImage();
    },
    { passive: true, capture: true }
  );

  window.addEventListener(
    "keydown",
    event => {
      if (!$currentLink) return;

      if (event.key === "Escape") {
        trackCloseModal();
        $currentLink = null;
      }

      if (event.key === "ArrowLeft") trackPrevImage("keyboard");
      if (event.key === "ArrowRight") trackNextImage("keyboard");
    },
    { passive: true }
  );
};

export default () => {
  checkTouchBrowsers();
  initNativeScroll();
  initMixPanelEvents();
  handleCarouselSwipe();

  if (!isTouchDevice()) {
    initScroll({
      parent: document,
      list: ".js-spangle-design-inspirations",
      grid: ".js-spangle-design-inspirations-grid",
      arrowLeft: ".js-spangle-design-inspirations-left",
      arrowRight: ".js-spangle-design-inspirations-right",
      loadMoreFn: loadMore
    });
  }
};
